import classNames from 'classnames';
import type { ReactNode } from 'react';

import { Alert, Icon, Space, Typography } from '@sravni/react-design-system';
import { CoinsPlus } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import { Question } from '@src/components/icons';
import { CurrencySymbol } from 'shared/config/internalization';

import { PromoGuideSheet } from '../PromoGuideSheet';

import styles from './PromoInfoBox.module.scss';

export const PromoInfoBox = ({ children }: { children: ReactNode }) => {
  const [visible, toogle] = useBoolean();

  return (
    <Alert
      className={styles.alert}
      title={
        <Space direction="row" justify="center" size={4} align="center" className={styles.alertContent}>
          <Icon className={classNames(styles.icon, 'h-color-static-light')} icon={<CoinsPlus />} />
          <Typography.Text size={14} className={classNames(styles.bonusTitle, 'h-color-static-light')}>
            Бонус от Сравни
          </Typography.Text>
          <Space direction="horizontal" className={styles.container}>
            <Typography.Text size={14} className="h-color-static-light">
              +500 {CurrencySymbol.RUB}
            </Typography.Text>
            <Icon className={styles.icon} onClick={toogle.on}>
              <Question />
            </Icon>
          </Space>
        </Space>
      }
    >
      <div>{children}</div>

      <PromoGuideSheet visible={visible} onClose={toogle.off} onButtonClick={toogle.off} />
    </Alert>
  );
};
